
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Icon,
  Input,
  Modal,
  Drawer,
  notification,
  Row,
  Select,
  Table,
  Tooltip
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import React, { PureComponent, useState } from 'react'

import { connect } from 'react-redux'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import { getPushPathWrapper, getUrlParams } from '../../../routes'

import { Editor } from 'react-draft-wysiwyg'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {
  ArticleTypeList,
  chooseEmailModalFxn,
  Countries,
  CustomCkEditor,
  DesignationList,
  InputBox,
  mentionsFeeds,
  NotificationBox, paymentModeList,
  ProcessList
} from '../../../components/_utils/appUtils'
import { CountriesList, JournalList } from '../../journals/actions'
import { singleOnlineSubmission } from '../../onlineSubmission/actions'
import { addMember, checkMemberEmails } from '../../members/actions'
import { addCourierFxn, addPaymentDetailsFxn, addSubscriptionActivityFxn, updateInvoiceStatusFxn } from '../action'
import Request from '../../../request'

@Form.create()
class AddPaymentDrawer extends PureComponent {
  state = {
    receivedDate: '',
    amount: '',
    modeOfPayment: '',


  }
  constructor(props) {
    super(props)
    console.log(props, "sdddddds")
  }

  resetFormData = () => {
    const { dispatch, form } = this.props
    form.setFieldsValue({
      receivedDate: '',
      amount: '',
      modeOfPayment: '',

    })
  }
  componentDidMount() {
    this.loadJournalList()
    this.getJournalList()
    this.setFormData()
  }
  setFormData = async () => {
    const { dispatch, form,totalAmount,invoiceId } = this.props
    setTimeout(() => {
      form.setFieldsValue({
        amount: totalAmount
      })
    }, 100)
  }
  getJournalList = async () => {
    let { data } = await Request.journalName()
    let journalList = []
    _.each(data, item => {
      journalList.push({
        _id: item._id,
        value: item.slugJournal,
        display: item.name
      })
    })
    console.log(journalList)

    this.setState({ journalNameList: journalList })
  }

  loadJournalList = async () => {
    const { dispatch, form } = this.props
    let { data } = await JournalList()
    this.setState({ journalListArr: data })
    form.setFieldsValue({ enterDate: moment() })
  }


  chooseDocument = e => {
    let { name, files } = e.target
    if (files && files.length) {
      this.setState({ [name]: files[0] })
    }
  }
  getJournalsVolumeData = async (id) => {
    let { data } = await Request.getJournalsVolumeList({ journalId: id })
    let volumeList = []
    _.each(data, (item) => {
      volumeList.push({
        _id: item._id,
        name: item.volumeName
      })
    })
    this.setState({ journalVolumeList: volumeList })
  }
  getJournalsIssueData = async (volumeName) => {
    let volume = _.find(this.state.journalVolumeList, (item) => {
      return item.name.toLowerCase() == volumeName.toLowerCase()
    })
    if (volume && volume._id) {

      let { data } = await Request.getJournalIssue()
      let issueList = []
      _.each(data, (item) => {
        issueList.push({
          _id: item._id,
          name: item.issueName
        })
      })
      this.setState({ journalIssueList: issueList })
    }
  }

  handleSubmit = e => {
    const { dispatch, form } = this.props
    let urlObj = getUrlParams('singleGeneralSubscription', window.location.pathname)
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        const subscriptionId = urlObj.id;
        valData.generalSubscriptionId = subscriptionId;
        if (!valData.paymentDetails || !Array.isArray(valData.paymentDetails)) {
          valData.paymentDetails = [];
        }
        console.log(this.props.invoiceId, "this.props.invoiceId")

        const paymentInfo = {
          amount: valData.amount,
          modeOfPayment: valData.modeOfPayment,
          receivedDate: valData.receivedDate || new Date(),

        };
        valData.invoiceId = this.props.invoiceId

        valData.paymentDetails.push(paymentInfo);
        let { success, message,data } = await dispatch(updateInvoiceStatusFxn(valData))
        if (success) {
          notification.success({
            message: message
          })
          this.props.reloadData()
          this.props.onClose()
          this.props.onPaymentAdded(data);
          this.resetFormData()
        }

      }
    })

  }


  render() {
    const {
      form: { getFieldDecorator, getFieldValue, setFieldsValue },
      loading
    } = this.props

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 24 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 24 }
      }
    }

    const inputSchma = {
      paymentFields:[
        {
          label: 'Received Date',
          key: 'receivedDate',
          required: true,
          placeholder: 'Received Date',
          type:'date'
        },
        {
          label: 'Mode Of Payment',
          key: 'modeOfPayment',
          required: true,
          placeholder: 'Mode Of Payment',
          type: 'select',
          options: paymentModeList,
          allowClear: true,
          keyAccessor: x => x,
          valueAccessor: x => x,
          onChange: (val) => {
            setFieldsValue({ modeOfPayment: val })
          }
        },
        {
          label: 'Amount',
          key: 'amount',
          required: true,
          placeholder: 'Amount',
        },

      ]

    }



    return (
      <Drawer
        title={'Add Payment Details'}
        width={'30%'}
        visible={this.props.visible}
        maskClosable={true}
        placement='right'
        onClose={this.props.onClose}>
        <Card bordered={true}>
          <Form
            onSubmit={this.handleSubmit}
            hideRequiredMark
            className={'inputForm'}>
            <Row gutter={16}>
              <Col span={24}>
                <Card  bordered={true}>
                  <Row gutter={16}>
                    {inputSchma.paymentFields.map((item, key) => {
                      return (
                        !item.hidden && (
                          <Col
                            span={item.span ? item.span : 12}
                            md={item.span ? item.span : 12}
                            sm={12}
                            xs={24}
                            key={key}>
                            {item.customField ? (
                              item.customField
                            ) : (
                              <GetEachFormFields
                                item={item}
                                getFieldDecorator={getFieldDecorator}
                                formItemLayout={formItemLayout}
                              />
                            )}
                          </Col>
                        )
                      )
                    })}
                  </Row>
                </Card>
              </Col>

            </Row>

            <Form.Item style={{ marginTop: 32 }}>
              <Button type="primary" htmlType="submit">
                SUBMIT
              </Button>
            </Form.Item>
          </Form>


        </Card>
      </Drawer>
    )
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
  pathname: router.location.pathname

})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(mapStateToProps,
  mapDispatchToProps
)(AddPaymentDrawer)
